/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Theme, ThemeOptions } from '@mui/material/styles';

type StateTheme = {
	ownerState: { className?: string; variant?: string; color?: string };
	theme: Theme;
};

export const Container: ThemeOptions = {
	components: {
		MuiContainer: {
			defaultProps: {
				maxWidth: false,
				// disableGutters: true,
			},
			styleOverrides: {
				root: ({ ownerState, theme }: StateTheme) =>
					theme.unstable_sx({
						...{},
						...{
							'&:empty': {
								display: 'none',

								'& + .MuiContainer-root:has(#CentroCheckout) #CentroCheckout ': {
									marginTop: 8,
								},
							},
							'&:is(main > section).MuiContainer-root.MuiContainer-maxWidthXl': {
								display: 'none', // if a layout has containers without widgets, hide the container
								'&:has(> .MuiGrid-root > section.MuiGrid-root > :not(:empty))': {
									display: 'block',
								},
							},
							'&:has(> .MuiBreadcrumbs-root)': {
								'--contentSpacing': theme.dimensions.contentSpacing,
								marginBottom: 'calc((0 - var(--contentSpacing)) * .25rem)',
								zIndex: 1,
							},
							'&:has(.anti-gap)': {
								marginBottom: { xs: -2, sm: -2, md: -6, lg: -8 },
							},
						},
					}),
			},
		},
	},
};
